<!--
Locations > room to screen
@author bmk11u
-->
<template>
  <div>
    <div class="btn-group w-100">
      <button v-on:click="goBack" class="btn btn-primary nav-button">Back</button>
      <router-link  v-if="authenticated" to="/" class="btn btn-primary nav-button">Home</router-link>
    </div>
    <h2>Rooms</h2>
    <h4>{{ buildingName }}</h4>
    <SearchList name="room" id="roomId" label="roomName" :data="'/map/buildings/' + buildingId + '/rooms'"
      :href="'map?buildingId=' + buildingId + '&toId={roomId}&toType=R'" @dataLoaded="onDataLoaded">
      <router-link :to="defaultUrl"
        class="list-group-item list-group-item-action list-group-item-primary">
        No thanks, just the building
      </router-link>
    </SearchList>
    <div id="pusher"></div>
    <Footer active="notifications" v-if="authenticated"/>
  </div>
</template>

<script>
import SearchList from '@/components/SearchList.vue'
import LocationsCommon from '@/mixins/LocationsCommon.js'
import Footer from '@/components/FooterMenu.vue'

export default {
  name: 'RoomTo',
  components: {
    SearchList,
    Footer
  },
  mixins: [
    LocationsCommon
  ],
  data () {
    return {
      authenticated: this.$cookies.get('authenticated'),
      buildingId: this.$route.query.buildingId,
      buildingName: this.$route.query.buildingName,
      defaultUrl: 'map?buildingId=' + this.$route.query.buildingId + '&toId=' + this.$route.query.buildingId + '&toType=B'
    }
  },
  methods: {
    onDataLoaded (numberOfItems) {
      if (numberOfItems === 0) {
        this.$router.push(this.defaultUrl + '&auto=true')
      }
    }
  }
}
</script>
